/* メニュー(職員) */
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { handleBrowserBack } from '../../BrowserBack';
import StaffNavbar from '../../molecules/StaffNavbar';

const StaffMenu: React.FC = () => {
  const [role, setRole] = useState('');
  const [user_id, setUserId] = useState('');
  const [has_loan_aproval_system, setHasLoanAprovalSystem] = useState(false);
  const [has_loan_aproval_system_interim_period, setHasLoanAprovalSystemInterimPeriod] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();

    // ユーザロールを設定する
    setUserRole();
  }, []);

  // ロールを設定する
  const setUserRole = () => {
    const node = document.getElementById('staff-menu');
    if (node === null) {
      // nodeが正しく取得できない場合は空文字とする
      setRole('');
      setHasLoanAprovalSystem(false);
      setHasLoanAprovalSystemInterimPeriod(false);
      return;
    }

    // ロール名をセット
    setRole(node.dataset.role as string);

    // user_idをセット
    setUserId(node.dataset.user_id as string);

    // 融資稟議システム導入済みフラグをセット
    if ((node.dataset.has_loan_aproval_system as string) === '1') {
      setHasLoanAprovalSystem(true);
    } else {
      setHasLoanAprovalSystem(false);
    }

    // 融資稟議システム導入済みフラグ（暫定期間のみ、移行期間は除外）フラグをセット
    if ((node.dataset.has_loan_aproval_system_interim_period as string) === '1') {
      setHasLoanAprovalSystemInterimPeriod(true);
    } else {
      setHasLoanAprovalSystemInterimPeriod(false);
    }
  };

  // 案件一覧ボタンを押下
  const handleOnClickReceptionList = () => {
    location.href = 'list';
  };
  // メンテナンスボタンを押下
  const handleOnClickMaintenance = () => {
    location.href = `${process.env.MIX_MOCK_URL}/maintenance/menu`;
  };
  // 顧客宛文書ボタンを押下
  const handleOnClickCustomerDocument = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/customer_document/list`;
  };
  // 法人一覧ボタンを押下
  const handleOnClickCorporateList = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/staff/corporate`;
  };

  // 案件一覧ボタンのJSXを出力する
  const jsxReceptionList = useCallback(() => {
    // 融資稟議システムが未導入の場合は表示する（移行中期間までは表示する）
    if (role === 'staff' && !has_loan_aproval_system) {
      return (
        <div className="container mt-3 pt-3">
          <button
            type="button"
            className="btn btn-bg-white btn-outline-success btn-block btn-lg btn-text-color"
            onClick={handleOnClickReceptionList}
          >
            案件一覧
          </button>
        </div>
      );
    }
    return <></>;
  }, [role]);

  // メンテナンスボタンのJSXを出力する
  const jsxMaintenanceMenu = useCallback(() => {
    // システム管理者の場合はメンテナンスボタンを表示する
    if (role === 'admin') {
      return (
        <div className="container mt-3 pt-3">
          <button
            type="button"
            className="btn btn-bg-white btn-outline-success btn-block btn-lg btn-text-color"
            onClick={handleOnClickMaintenance}
          >
            メンテナンス
          </button>
        </div>
      );
    }
    return <></>;
  }, [role]);

  // 顧客宛文書ボタンのJSXを出力する
  const jsxCustomerDocument = useCallback(() => {
    // 暫定期間以外の場合顧客宛文書ボタンを表示する
    if (has_loan_aproval_system_interim_period) {
      return (
        <div className="container mt-3 pt-3">
          <button
            type="button"
            className="btn btn-bg-white btn-outline-success btn-block btn-lg btn-text-color"
            onClick={handleOnClickCustomerDocument}
          >
            顧客宛文書
          </button>
        </div>
      );
    }
    return <></>;
  }, [role]);

  // 法人一覧ボタンのJSXを出力する
  const jsxCorporateList = useCallback(() => {
    // 一般権限かつ暫定期間以外の場合は法人一覧ボタンを表示する
    if (role === 'staff' && has_loan_aproval_system_interim_period) {
      return (
        <div className="container mt-3 pt-3">
          <button
            type="button"
            className="btn btn-bg-white btn-outline-success btn-block btn-lg btn-text-color"
            onClick={handleOnClickCorporateList}
          >
            法人一覧
          </button>
        </div>
      );
    }
    return <></>;
  }, [role]);

  return (
    <>
      <StaffNavbar user_role={role} has_loan_aproval_system={has_loan_aproval_system} />
      <form>
        <main className="mx-3">
          <div className="p-3">
            <div className="title">
              <div className="row">
                <div className="col-12">
                  <p>WEBメニュー</p>
                </div>
              </div>
            </div>
          </div>

          {jsxReceptionList()}
          {jsxMaintenanceMenu()}
          {jsxCustomerDocument()}
          {jsxCorporateList()}
        </main>
      </form>
    </>
  );
};
if (document.getElementById('staff-menu')) {
  ReactDOM.render(<StaffMenu />, document.getElementById('staff-menu'));
}
